/**
 * The corner radius of an iOS 26 system menu's platter, measured against a presented `UIMenu`: a
 * bare glass of the platter's frame matches its pixels at 32pt and at no other whole radius. A
 * platter shorter than 64pt is a capsule.
 */
export const NATIVE_MENU_CORNER_RADIUS = 32;
